import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, BookOpen, ArrowRight } from "lucide-react";
import { api, imgUrl } from "@/lib/api";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Blog() {
  const [posts, setPosts] = useState(null);

  usePageMeta(
    "The Beauty Trade Club Blog — Tips on Buying, Selling & Trading Makeup",
    "Fresh daily guides and tips on reselling makeup, buying used beauty safely, and getting the most from Beauty Trade Club.",
    "/blog"
  );

  useEffect(() => {
    api.get("/blog").then(({ data }) => setPosts(data)).catch(() => setPosts([]));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-14" data-testid="blog-page">
      <div className="text-center mb-12">
        <div className="flex items-center justify-center gap-2 text-[#E8956B] text-sm font-extrabold uppercase tracking-[0.3em] mb-4">
          <BookOpen size={16} /> The Club Journal
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-neutral-900">Beauty Trade Club Blog</h1>
        <p className="text-neutral-500 mt-3 max-w-2xl mx-auto">
          Fresh tips, guides and beauty resale know-how — a new story every day.
        </p>
      </div>

      {posts === null ? (
        <div className="flex justify-center py-24"><Loader2 className="animate-spin text-[#E8956B]" /></div>
      ) : posts.length === 0 ? (
        <p className="text-center text-neutral-400 py-20" data-testid="blog-empty">No posts yet — check back soon! ✨</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="blog-grid">
          {posts.map((p) => (
            <Link
              to={`/blog/${p.slug}`}
              key={p.id}
              data-testid={`blog-card-${p.slug}`}
              className="group bg-white border border-neutral-200 rounded-2xl overflow-hidden hover:shadow-lg hover:-translate-y-0.5 transition-all"
            >
              <div className="aspect-[16/10] bg-neutral-100 overflow-hidden">
                {p.image_url ? (
                  <img src={imgUrl(p.image_url)} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-[#E8956B]"><BookOpen size={40} /></div>
                )}
              </div>
              <div className="p-5">
                <p className="text-xs text-neutral-400 font-semibold">{p.date}</p>
                <h2 className="font-display text-xl font-bold text-neutral-900 mt-1 leading-snug line-clamp-2">{p.title}</h2>
                <p className="text-sm text-neutral-500 mt-2 line-clamp-3">{p.excerpt}</p>
                <span className="inline-flex items-center gap-1 text-[#CE744A] text-sm font-bold mt-3 group-hover:gap-2 transition-all">
                  Read more <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
